/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatbotPerspectiveRole } from './ChatbotPerspectiveRole';
import {
    ChatbotPerspectiveRoleFromJSON,
    ChatbotPerspectiveRoleFromJSONTyped,
    ChatbotPerspectiveRoleToJSON,
    ChatbotPerspectiveRoleToJSONTyped,
} from './ChatbotPerspectiveRole';
import type { ChatbotResponseDepthLevel } from './ChatbotResponseDepthLevel';
import {
    ChatbotResponseDepthLevelFromJSON,
    ChatbotResponseDepthLevelFromJSONTyped,
    ChatbotResponseDepthLevelToJSON,
    ChatbotResponseDepthLevelToJSONTyped,
} from './ChatbotResponseDepthLevel';
import type { ChatbotResponseLength } from './ChatbotResponseLength';
import {
    ChatbotResponseLengthFromJSON,
    ChatbotResponseLengthFromJSONTyped,
    ChatbotResponseLengthToJSON,
    ChatbotResponseLengthToJSONTyped,
} from './ChatbotResponseLength';
import type { ChatbotTone } from './ChatbotTone';
import {
    ChatbotToneFromJSON,
    ChatbotToneFromJSONTyped,
    ChatbotToneToJSON,
    ChatbotToneToJSONTyped,
} from './ChatbotTone';

/**
 * 
 * @export
 * @interface ChatbotSettingsOverrides
 */
export interface ChatbotSettingsOverrides {
    /**
     * 
     * @type {ChatbotResponseDepthLevel}
     * @memberof ChatbotSettingsOverrides
     */
    responseDepthLevel?: ChatbotResponseDepthLevel | null;
    /**
     * 
     * @type {ChatbotTone}
     * @memberof ChatbotSettingsOverrides
     */
    tone?: ChatbotTone | null;
    /**
     * 
     * @type {ChatbotPerspectiveRole}
     * @memberof ChatbotSettingsOverrides
     */
    perspectiveRole?: ChatbotPerspectiveRole | null;
    /**
     * 
     * @type {number}
     * @memberof ChatbotSettingsOverrides
     */
    safetyConservativeness?: number | null;
    /**
     * 
     * @type {ChatbotResponseLength}
     * @memberof ChatbotSettingsOverrides
     */
    responseLength?: ChatbotResponseLength | null;
}



/**
 * Check if a given object implements the ChatbotSettingsOverrides interface.
 */
export function instanceOfChatbotSettingsOverrides(value: object): value is ChatbotSettingsOverrides {
    return true;
}

export function ChatbotSettingsOverridesFromJSON(json: any): ChatbotSettingsOverrides {
    return ChatbotSettingsOverridesFromJSONTyped(json, false);
}

export function ChatbotSettingsOverridesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatbotSettingsOverrides {
    if (json == null) {
        return json;
    }
    return {
        
        'responseDepthLevel': json['responseDepthLevel'] == null ? undefined : ChatbotResponseDepthLevelFromJSON(json['responseDepthLevel']),
        'tone': json['tone'] == null ? undefined : ChatbotToneFromJSON(json['tone']),
        'perspectiveRole': json['perspectiveRole'] == null ? undefined : ChatbotPerspectiveRoleFromJSON(json['perspectiveRole']),
        'safetyConservativeness': json['safetyConservativeness'] == null ? undefined : json['safetyConservativeness'],
        'responseLength': json['responseLength'] == null ? undefined : ChatbotResponseLengthFromJSON(json['responseLength']),
    };
}

export function ChatbotSettingsOverridesToJSON(json: any): ChatbotSettingsOverrides {
    return ChatbotSettingsOverridesToJSONTyped(json, false);
}

export function ChatbotSettingsOverridesToJSONTyped(value?: ChatbotSettingsOverrides | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'responseDepthLevel': ChatbotResponseDepthLevelToJSON(value['responseDepthLevel']),
        'tone': ChatbotToneToJSON(value['tone']),
        'perspectiveRole': ChatbotPerspectiveRoleToJSON(value['perspectiveRole']),
        'safetyConservativeness': value['safetyConservativeness'],
        'responseLength': ChatbotResponseLengthToJSON(value['responseLength']),
    };
}

